export function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}

export function dateFormat(date, startDate) {
    if (date !== "0000-00-00") {

        let recentDate = new Date(date)
        let year = recentDate.getFullYear()
        let month = (recentDate.getMonth() + 1).toString().length < 2 ? `0${(recentDate.getMonth() + 1)}` : (recentDate.getMonth() + 1)
        let day = recentDate.getDate().toString().length < 2 ? `0${recentDate.getDate()}` : recentDate.getDate()
        return `${year}-${month}-${day}`
    } else {
        let recentDate = new Date(date)
        let year = recentDate.getFullYear()
        let month = (recentDate.getMonth() + 1).toString().length < 2 ? `0${(recentDate.getMonth() + 1)}` : (recentDate.getMonth() + 1)
        let day = recentDate.getDate().toString().length < 2 ? `0${recentDate.getDate()}` : recentDate.getDate()
        return `${year}-${month}-${day}`
    }
}

export function checkImageType(image) {
    if (!image || typeof image !== 'string') {
        return false;
    }
    
    if (image.toLowerCase().includes('.jpg') ||
        image.toLowerCase().includes('jpeg') ||
        image.toLowerCase().includes('.png')) {
            return (image)
    }
    return false;
}